document.addEventListener("DOMContentLoaded", function() {
    var targetNode = document.body;
    var config = { childList: true, subtree: true };

    var callback = function(mutationsList, observer) {
        for (var mutation of mutationsList) {
            if (mutation.type === 'childList') {
              if(document.querySelector('#rebuy-cart')){
                if(document.querySelectorAll('.rebuy-cart__flyout-recommendations .rebuy-widget .flickity-viewport .rebuy-product-block').length > 0){
                  if(!document.querySelector('.rebuy-cart__flyout-empty-cart')){
                    if(!document.querySelector('.rebuy-cart__flyout-recommendations .rebuy-widget .rebuy-widget-container .brand-title')){
                      const primary_title = document.querySelector('.rebuy-cart__flyout-recommendations .rebuy-widget .rebuy-widget-container .primary-title');
                      const brand_title = '<span class="brand-title">Personalize with a Charm</span>'

                      primary_title.insertAdjacentHTML('afterend', brand_title);
                    }
                    
                    const elements = document.querySelectorAll('.rebuy-cart__flyout-recommendations .rebuy-widget .flickity-viewport .rebuy-product-block');
  
                    elements.forEach((item, index)=>{
                      if(!item.querySelector('.rebuy-product-actions a')){
                        var url = item.querySelector('.rebuy-product-media a').href
                        item.querySelector('.rebuy-product-actions').innerHTML = `<a class="rebuy-button" href=${url}>VIEW DETAILS</a>`;
                      }
                      else if(item.querySelector('.rebuy-product-actions a').href != item.querySelector('.rebuy-product-media a').href){
                        var url = item.querySelector('.rebuy-product-media a').href
                        item.querySelector('.rebuy-product-actions').innerHTML = `<a class="rebuy-button" href=${url}>VIEW DETAILS</a>`;
                      }
                      // if(!item.querySelector('.rebuy-product-media a img').classList.contains('feched')){
                      //   item.querySelector('.rebuy-product-media a img').classList.add('feched')
                      //   var urls = item.querySelector('.rebuy-product-media a').href
                      //   var count = urls.split('?')[0].split('/').length
                      //   var product_id = urls.split('?')[0].split('/')[count - 1]
    
                      //   console.log('image', product_id)
    
                      //   function getProductImage(productId){
                      //     fetch(`/products/${productId}.js`)
                      //     .then(response => response.json())
                      //     .then(product => {
                      //       const images = product.images;
                      //       item.querySelector('.rebuy-product-media a img').src = images[0]
                      //     })
                      //     .catch(error => {
                      //       console.error('Error fetching product images:', error);
                      //     });
                      //   }
    
                      //   getProductImage(product_id);
                      // }
                    })
                  }
                }

                if(document.querySelector('.rebuy-cart__flyout-empty-cart')){
                  if(!document.querySelector('.rebuy-cart__flyout-recommendations').classList.contains('hidden-element')){
                    document.querySelector('.rebuy-cart__flyout-recommendations').classList.add('hidden-element');
                  }
                }
                else{
                  if(document.querySelector('.rebuy-cart__flyout-recommendations').classList.contains('hidden-element')){
                    document.querySelector('.rebuy-cart__flyout-recommendations').classList.remove('hidden-element');
                  }
                }
              }
            }
        }
    };

    var observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
});